import { defineComponent as T, ref as M, computed as k, onMounted as F, onUnmounted as W, watchEffect as U, nextTick as S, provide as Z, inject as q, createElementBlock as w, openBlock as h, createElementVNode as N, getCurrentInstance as Q, callWithAsyncErrorHandling as J, resolveComponent as R, normalizeClass as P, createVNode as D, withCtx as C, renderSlot as $, createBlock as B, Transition as X, normalizeStyle as Y, Fragment as L, renderList as G, withModifiers as ee, toDisplayString as V, createCommentVNode as te, createTextVNode as ne, resolveDynamicComponent as oe } from "vue";
import { t as O, o as g, H as _, N as j, u as ae, a as f } from "./dom-B5R6OWVp.js";
import { u as re, p as le, l as E, y as se, c as ue, a as y, x as ie } from "./use-tracked-pointer-D7o8jeoa.js";
import { p as ce } from "./use-tree-walker-AStIFPaK.js";
import { b as de } from "./use-resolve-button-type-XAZYZJQ_.js";
import { w as pe, h as ve, _ as K, v as me, N as H, O as fe } from "./focus-management-uTsAyIu4.js";
import { _ as ge } from "./_plugin-vue_export-helper-CHgC5LLL.js";
var be = ((t) => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(be || {}), Ie = ((t) => (t[t.Pointer = 0] = "Pointer", t[t.Other = 1] = "Other", t))(Ie || {});
function ye(t) {
  requestAnimationFrame(() => requestAnimationFrame(t));
}
let z = Symbol("MenuContext");
function A(t) {
  let d = q(z, null);
  if (d === null) {
    let b = new Error(`<${t} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(b, A), b;
  }
  return d;
}
let he = T({ name: "Menu", props: { as: { type: [Object, String], default: "template" } }, setup(t, { slots: d, attrs: b }) {
  let p = M(1), e = M(null), l = M(null), u = M([]), v = M(""), c = M(null), i = M(1);
  function n(s = (a) => a) {
    let a = c.value !== null ? u.value[c.value] : null, o = fe(s(u.value.slice()), (I) => g(I.dataRef.domRef)), r = a ? o.indexOf(a) : null;
    return r === -1 && (r = null), { items: o, activeItemIndex: r };
  }
  let m = { menuState: p, buttonRef: e, itemsRef: l, items: u, searchQuery: v, activeItemIndex: c, activationTrigger: i, closeMenu: () => {
    p.value = 1, c.value = null;
  }, openMenu: () => p.value = 0, goToItem(s, a, o) {
    let r = n(), I = ie(s === y.Specific ? { focus: y.Specific, id: a } : { focus: s }, { resolveItems: () => r.items, resolveActiveIndex: () => r.activeItemIndex, resolveId: (x) => x.id, resolveDisabled: (x) => x.dataRef.disabled });
    v.value = "", c.value = I, i.value = o ?? 1, u.value = r.items;
  }, search(s) {
    let a = v.value !== "" ? 0 : 1;
    v.value += s.toLowerCase();
    let o = (c.value !== null ? u.value.slice(c.value + a).concat(u.value.slice(0, c.value + a)) : u.value).find((I) => I.dataRef.textValue.startsWith(v.value) && !I.dataRef.disabled), r = o ? u.value.indexOf(o) : -1;
    r === -1 || r === c.value || (c.value = r, i.value = 1);
  }, clearSearch() {
    v.value = "";
  }, registerItem(s, a) {
    let o = n((r) => [...r, { id: s, dataRef: a }]);
    u.value = o.items, c.value = o.activeItemIndex, i.value = 1;
  }, unregisterItem(s) {
    let a = n((o) => {
      let r = o.findIndex((I) => I.id === s);
      return r !== -1 && o.splice(r, 1), o;
    });
    u.value = a.items, c.value = a.activeItemIndex, i.value = 1;
  } };
  return se([e, l], (s, a) => {
    var o;
    m.closeMenu(), pe(a, ve.Loose) || (s.preventDefault(), (o = g(e)) == null || o.focus());
  }, k(() => p.value === 0)), Z(z, m), ue(k(() => ae(p.value, { 0: E.Open, 1: E.Closed }))), () => {
    let s = { open: p.value === 0, close: m.closeMenu };
    return _({ ourProps: {}, theirProps: t, slot: s, slots: d, attrs: b, name: "Menu" });
  };
} }), Me = T({ name: "MenuButton", props: { disabled: { type: Boolean, default: !1 }, as: { type: [Object, String], default: "button" }, id: { type: String, default: () => `headlessui-menu-button-${O()}` } }, setup(t, { attrs: d, slots: b, expose: p }) {
  let e = A("MenuButton");
  p({ el: e.buttonRef, $el: e.buttonRef });
  function l(i) {
    switch (i.key) {
      case f.Space:
      case f.Enter:
      case f.ArrowDown:
        i.preventDefault(), i.stopPropagation(), e.openMenu(), S(() => {
          var n;
          (n = g(e.itemsRef)) == null || n.focus({ preventScroll: !0 }), e.goToItem(y.First);
        });
        break;
      case f.ArrowUp:
        i.preventDefault(), i.stopPropagation(), e.openMenu(), S(() => {
          var n;
          (n = g(e.itemsRef)) == null || n.focus({ preventScroll: !0 }), e.goToItem(y.Last);
        });
        break;
    }
  }
  function u(i) {
    switch (i.key) {
      case f.Space:
        i.preventDefault();
        break;
    }
  }
  function v(i) {
    t.disabled || (e.menuState.value === 0 ? (e.closeMenu(), S(() => {
      var n;
      return (n = g(e.buttonRef)) == null ? void 0 : n.focus({ preventScroll: !0 });
    })) : (i.preventDefault(), e.openMenu(), ye(() => {
      var n;
      return (n = g(e.itemsRef)) == null ? void 0 : n.focus({ preventScroll: !0 });
    })));
  }
  let c = de(k(() => ({ as: t.as, type: d.type })), e.buttonRef);
  return () => {
    var i;
    let n = { open: e.menuState.value === 0 }, { id: m, ...s } = t, a = { ref: e.buttonRef, id: m, type: c.value, "aria-haspopup": "menu", "aria-controls": (i = g(e.itemsRef)) == null ? void 0 : i.id, "aria-expanded": t.disabled ? void 0 : e.menuState.value === 0, onKeydown: l, onKeyup: u, onClick: v };
    return _({ ourProps: a, theirProps: s, slot: n, attrs: d, slots: b, name: "MenuButton" });
  };
} }), ke = T({ name: "MenuItems", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: () => `headlessui-menu-items-${O()}` } }, setup(t, { attrs: d, slots: b, expose: p }) {
  let e = A("MenuItems"), l = M(null);
  p({ el: e.itemsRef, $el: e.itemsRef }), ce({ container: k(() => g(e.itemsRef)), enabled: k(() => e.menuState.value === 0), accept(n) {
    return n.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : n.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(n) {
    n.setAttribute("role", "none");
  } });
  function u(n) {
    var m;
    switch (l.value && clearTimeout(l.value), n.key) {
      case f.Space:
        if (e.searchQuery.value !== "") return n.preventDefault(), n.stopPropagation(), e.search(n.key);
      case f.Enter:
        if (n.preventDefault(), n.stopPropagation(), e.activeItemIndex.value !== null) {
          let s = e.items.value[e.activeItemIndex.value];
          (m = g(s.dataRef.domRef)) == null || m.click();
        }
        e.closeMenu(), K(g(e.buttonRef));
        break;
      case f.ArrowDown:
        return n.preventDefault(), n.stopPropagation(), e.goToItem(y.Next);
      case f.ArrowUp:
        return n.preventDefault(), n.stopPropagation(), e.goToItem(y.Previous);
      case f.Home:
      case f.PageUp:
        return n.preventDefault(), n.stopPropagation(), e.goToItem(y.First);
      case f.End:
      case f.PageDown:
        return n.preventDefault(), n.stopPropagation(), e.goToItem(y.Last);
      case f.Escape:
        n.preventDefault(), n.stopPropagation(), e.closeMenu(), S(() => {
          var s;
          return (s = g(e.buttonRef)) == null ? void 0 : s.focus({ preventScroll: !0 });
        });
        break;
      case f.Tab:
        n.preventDefault(), n.stopPropagation(), e.closeMenu(), S(() => me(g(e.buttonRef), n.shiftKey ? H.Previous : H.Next));
        break;
      default:
        n.key.length === 1 && (e.search(n.key), l.value = setTimeout(() => e.clearSearch(), 350));
        break;
    }
  }
  function v(n) {
    switch (n.key) {
      case f.Space:
        n.preventDefault();
        break;
    }
  }
  let c = le(), i = k(() => c !== null ? (c.value & E.Open) === E.Open : e.menuState.value === 0);
  return () => {
    var n, m;
    let s = { open: e.menuState.value === 0 }, { id: a, ...o } = t, r = { "aria-activedescendant": e.activeItemIndex.value === null || (n = e.items.value[e.activeItemIndex.value]) == null ? void 0 : n.id, "aria-labelledby": (m = g(e.buttonRef)) == null ? void 0 : m.id, id: a, onKeydown: u, onKeyup: v, role: "menu", tabIndex: 0, ref: e.itemsRef };
    return _({ ourProps: r, theirProps: o, slot: s, attrs: d, slots: b, features: j.RenderStrategy | j.Static, visible: i.value, name: "MenuItems" });
  };
} }), we = T({ name: "MenuItem", inheritAttrs: !1, props: { as: { type: [Object, String], default: "template" }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: () => `headlessui-menu-item-${O()}` } }, setup(t, { slots: d, attrs: b, expose: p }) {
  let e = A("MenuItem"), l = M(null);
  p({ el: l, $el: l });
  let u = k(() => e.activeItemIndex.value !== null ? e.items.value[e.activeItemIndex.value].id === t.id : !1), v = k(() => ({ disabled: t.disabled, textValue: "", domRef: l }));
  F(() => {
    var o, r;
    let I = (r = (o = g(l)) == null ? void 0 : o.textContent) == null ? void 0 : r.toLowerCase().trim();
    I !== void 0 && (v.value.textValue = I);
  }), F(() => e.registerItem(t.id, v)), W(() => e.unregisterItem(t.id)), U(() => {
    e.menuState.value === 0 && u.value && e.activationTrigger.value !== 0 && S(() => {
      var o, r;
      return (r = (o = g(l)) == null ? void 0 : o.scrollIntoView) == null ? void 0 : r.call(o, { block: "nearest" });
    });
  });
  function c(o) {
    if (t.disabled) return o.preventDefault();
    e.closeMenu(), K(g(e.buttonRef));
  }
  function i() {
    if (t.disabled) return e.goToItem(y.Nothing);
    e.goToItem(y.Specific, t.id);
  }
  let n = re();
  function m(o) {
    n.update(o);
  }
  function s(o) {
    n.wasMoved(o) && (t.disabled || u.value || e.goToItem(y.Specific, t.id, 0));
  }
  function a(o) {
    n.wasMoved(o) && (t.disabled || u.value && e.goToItem(y.Nothing));
  }
  return () => {
    let { disabled: o } = t, r = { active: u.value, disabled: o, close: e.closeMenu }, { id: I, ...x } = t;
    return _({ ourProps: { id: I, ref: l, role: "menuitem", tabIndex: o === !0 ? void 0 : -1, "aria-disabled": o === !0 ? !0 : void 0, disabled: void 0, onClick: c, onFocus: i, onPointerenter: m, onMouseenter: m, onPointermove: s, onMousemove: s, onPointerleave: a, onMouseleave: a }, theirProps: { ...b, ...x }, slot: r, attrs: b, slots: d, name: "MenuItem" });
  };
} });
function Se(t, d) {
  return h(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    N("path", { d: "M10 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM10 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM11.5 15.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z" })
  ]);
}
const xe = T({
  inheritAttrs: !1,
  components: { MenuWrapper: he, MenuButton: Me, MenuItems: ke, MenuItem: we, EllipsisVerticalIcon: Se },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    clickArgs: [Object, Number],
    size: {
      type: String,
      default: () => "tt-w-56"
    },
    position: {
      type: String,
      default: () => "tt-right-0"
    },
    containerClass: String
  },
  slots: Object,
  emits: {
    close: () => !0,
    open: () => !0
  },
  setup(t, { emit: d }) {
    const b = Q(), p = M(), e = k(
      () => t.items.map((l) => ({
        ...l,
        click: l.click ? () => {
          b ? J(l.click, b, 6, [t.clickArgs]) : l.click(t.clickArgs);
        } : void 0
      }))
    );
    return {
      contentStyle: p,
      myitems: e,
      hasIcon: k(() => e.value.find((l) => l.icon !== void 0) !== void 0),
      leave() {
        d("close");
      },
      enter(l) {
        d("open"), S(() => {
          const u = l == null ? void 0 : l.getBoundingClientRect();
          if (u && l.scrollHeight + u.top > window.innerHeight) {
            p.value = `overflow-y: auto; max-height: ${(window.innerHeight - u.top - 20).toFixed(0)}px !important;`;
            return;
          }
          p.value = "";
        });
      }
    };
  }
}), Re = { class: "tx-dropdown-button" }, Pe = ["onClick"], Ce = {
  key: 1,
  class: "tt-w-7"
};
function Te(t, d, b, p, e, l) {
  const u = R("EllipsisVerticalIcon"), v = R("MenuButton"), c = R("MenuItem"), i = R("MenuItems"), n = R("MenuWrapper");
  return h(), w("div", {
    class: P(["tx-dropdown", t.$props.containerClass])
  }, [
    D(n, {
      as: "div",
      class: "tt-relative tt-inline-block tt-text-left"
    }, {
      default: C(({ open: m, close: s }) => [
        N("div", Re, [
          D(v, {
            class: P(t.$attrs.class)
          }, {
            default: C(() => [
              "default" in t.$slots ? $(t.$slots, "default", {
                key: 0,
                open: m
              }) : (h(), B(u, {
                key: 1,
                class: "tt-w-[1rem]"
              }))
            ]),
            _: 2
          }, 1032, ["class"])
        ]),
        D(X, {
          "enter-active-class": "tt-transition tt-duration-100 tt-ease-out",
          "enter-from-class": "tt-transform tt-scale-95 tt-opacity-0",
          "enter-to-class": "tt-transform tt-scale-100 tt-opacity-100",
          "leave-active-class": "tt-transition tt-duration-75 tt-ease-in",
          "leave-from-class": "tt-transform tt-scale-100 tt-opacity-100",
          "leave-to-class": "tt-transform tt-scale-95 tt-opacity-0",
          onLeave: t.leave,
          onEnter: t.enter
        }, {
          default: C(() => [
            D(i, { as: "template" }, {
              default: C(() => [
                N("div", {
                  class: P([[t.$props.size, t.$props.position], "tt-p-1 tt-mt-2 tt-divide-y tt-divide-gray-100 tt-rounded tt-absolute tt-z-30 tt-bg-white tt-shadow-lg tt-ring-1 tt-ring-black tt-ring-opacity-5 focus:tt-outline-none"]),
                  style: Y(t.contentStyle)
                }, [
                  "content" in t.$slots ? $(t.$slots, "content", {
                    key: 0,
                    close: s
                  }) : (h(!0), w(L, { key: 1 }, G(t.myitems || [], (a, o) => (h(), B(c, { key: o }, {
                    default: C(({ active: r }) => [
                      a.click ? (h(), w("button", {
                        key: 1,
                        onClick: a.click,
                        class: P(["tt-group tt-flex tt-w-full tt-items-center tt-p-2 tt-text-sm", { "!tt-border-b-2 !tt-border-gray-200": a.borderB, "tw-bg-primary tt-text-white tt-rounded-md": r, "tt-text-gray-900": !r }])
                      }, [
                        t.hasIcon ? (h(), w(L, { key: 0 }, [
                          a.icon ? (h(), B(oe(a.icon), {
                            key: 0,
                            class: "tt-mr-2 tt-h-5 tt-w-5",
                            "aria-hidden": "true"
                          })) : (h(), w("span", Ce))
                        ], 64)) : te("", !0),
                        ne(" " + V(a.title), 1)
                      ], 10, Pe)) : (h(), w("div", {
                        key: 0,
                        onClick: d[0] || (d[0] = ee(() => {
                        }, ["prevent"])),
                        class: P(["tt-p-2 tt-text-sm tt-cursor-default", { "tt-border-b tt-border-gray-200": a.borderB }])
                      }, V(a.title), 3))
                    ]),
                    _: 2
                  }, 1024))), 128))
                ], 6)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["onLeave", "onEnter"])
      ]),
      _: 3
    })
  ], 2);
}
const Fe = /* @__PURE__ */ ge(xe, [["render", Te]]);
export {
  Fe as default
};
//# sourceMappingURL=Dropdown-Cy_Jl-0g.js.map
